import React, { useState } from "react";
import { Settings2 } from "lucide-react";
import Dialog from "./Dialog";
import ThemeToggle from "./ThemeToggle";

export default function SettingsButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="icon-button" aria-label="Settings" onClick={() => setOpen(true)}>
        <Settings2 size={18} aria-hidden="true" />
      </button>
      <Dialog open={open} onClose={() => setOpen(false)} title="Settings">
        <ThemeToggle />
      </Dialog>
    </>
  );
}
